import React from 'react';
import { ToneBadge } from '../../../../../components/ui/ToneBadge';
import { kitLabel, kitSummary } from '../../../../../features/catalog/catalogUtils';

/**
 * What the warehouse has to do differently with a product, as badges.
 *
 * Only what is switched on is drawn — a row of "No" would be noise — except the
 * rotation class, which every product has. The unit shows up only when it takes
 * decimals: that is when it changes what can be typed as a quantity.
 *
 * @param {object} props
 * @param {object} props.product - As `products/catalog/` answers it.
 */
export const ProductFlags = ({ product }) => (
  <div data-testid="product-flags" className="flex flex-wrap items-center gap-1.5 max-w-[280px]">
    {product.lot_controlled && <ToneBadge tone="info">Lote</ToneBadge>}
    {product.expiry_controlled && <ToneBadge tone="warning">Vence</ToneBadge>}
    {product.serial_controlled && <ToneBadge tone="info">Serie</ToneBadge>}
    {product.is_kit && (
      <ToneBadge tone="success" title={kitSummary(product)} testId="product-kit-badge">
        {kitLabel(product)}
      </ToneBadge>
    )}
    {product.allows_fractional_qty && <ToneBadge>{product.base_uom}</ToneBadge>}
    <ToneBadge title="Clase de rotación">{product.rotation_class}</ToneBadge>
  </div>
);
